import React from "react";
import { INicu } from "../types/interfaces/INicu";
import { CardContent, Grid, Typography } from "@mui/material";

//This function creates a card for nicu info.
export default function NicuDetailNicuCard(props: {nicu: INicu}) {
    return (
        <React.Fragment>
            <CardContent>
                <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 2 }}>
                    <Grid item xs={5}>
                        <Typography variant="h6">NICU Beds:</Typography>
                    </Grid>
                    <Grid item xs={7}>
                        <Typography>{props.nicu.NumberOfBeds}</Typography>
                    </Grid>
                    <Grid item xs={5}>
                        <Typography variant="h6">Level of NICU:</Typography>
                    </Grid>
                    <Grid item xs={7}>
                        <Typography>{props.nicu.LevelId}</Typography>
                    </Grid>
                    <Grid item xs={5}>
                        <Typography variant="h6">Level Assigned By:</Typography>
                    </Grid>
                    <Grid item xs={7}>
                        <Typography>{props.nicu.LevelAssignerName}</Typography>
                    </Grid>
                    <Grid item xs={5}>
                        <Typography variant="h6">Verification ID:</Typography>
                    </Grid>
                    <Grid item xs={7}>
                        <Typography>{props.nicu.VerificationId}</Typography>
                    </Grid>
                </Grid>
            </CardContent>
        </React.Fragment>
    );
}